import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const anchorNavigationDropdownFn = /* @__PURE__ */ createRecipe('anchor-navigation-dropdown', {
  "variant": "outer"
}, [])

const anchorNavigationDropdownVariantMap = {
  "variant": [
    "outer",
    "inner"
  ]
}

const anchorNavigationDropdownVariantKeys = Object.keys(anchorNavigationDropdownVariantMap)

export const anchorNavigationDropdown = /* @__PURE__ */ Object.assign(memo(anchorNavigationDropdownFn.recipeFn), {
  __recipe__: true,
  __name__: 'anchorNavigationDropdown',
  __getCompoundVariantCss__: anchorNavigationDropdownFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: anchorNavigationDropdownVariantKeys,
  variantMap: anchorNavigationDropdownVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, anchorNavigationDropdownVariantKeys)
  },
  getVariantProps: anchorNavigationDropdownFn.getVariantProps,
})